import React from 'react'

type Props = {
  /**
   * The query expression to display. If null/undefined, displays 'true' (unfiltered)
   */
  expression: string | null | undefined
}

export default function DataBridgeQueryPreview({ expression }: Props) {
  const query = expression ?? 'true'
  const numRows = Math.max(query.split('\n').length, 5)

  return (
    <div
      className="relative flex w-full overflow-auto py-4"
      data-testid="dataBridgeQueryPreview"
    >
      <div className="flex flex-col px-4">
        {Array.from({ length: numRows }).map((_, i) => (
          <div key={i} className="flex items-center justify-center">
            <span className="font-plex-mono text-foreground-subtle text-[13px]">
              {i + 1}
            </span>
          </div>
        ))}
      </div>
      <div className="flex flex-1 flex-col">
        {query.split('\n').map((line, i) => (
          <div key={i} className="flex items-center">
            <span className="font-plex-mono text-foreground-normal text-[13px]">
              {line}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
